import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrafficMatrix from './components/TrafficMatrix';
import { useNavigate } from 'react-router-dom';

const goToForm = (navigate: ReturnType<typeof useNavigate>) => {
  navigate('/');
  setTimeout(() => {
    const el = document.getElementById('contact-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, 300);
};

export default function Services() {
  const navigate = useNavigate();

  const handleCTA = () => goToForm(navigate);

  useEffect(() => {
    document.title = '六大核心服務 - 全鏈獲客整合行銷 | 自動化漏斗系統建置';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '全鏈獲客整合行銷提供六大核心服務：深度需求診斷、痛點腳本規劃、實體拍攝剪輯、漏斗與自動化系統建置、數據監控優化、品牌數位基建架設。從診斷到優化，完整覆蓋全鏈獲客每一關鍵環節。');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`);

    const scriptId = 'jsonld-services';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify([
        {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首頁', item: import.meta.env.VITE_SITE_URL || 'https://example.com' },
            { '@type': 'ListItem', position: 2, name: '六大核心服務', item: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services` },
          ],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services#webpage`,
          url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`,
          name: '六大核心服務 - 全鏈獲客整合行銷',
          description: '從深度需求診斷到數據監控優化，完整覆蓋全鏈獲客每一關鍵環節。',
          inLanguage: 'zh-TW',
          isPartOf: {
            '@type': 'WebSite',
            name: '全鏈獲客整合行銷',
            url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          },
          mainEntity: {
            '@type': 'ItemList',
            name: '六大核心服務',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '深度需求診斷', description: '針對企業目前的獲客瓶頸進行全方位拆解，精準判斷適用漏斗類型。' },
              { '@type': 'ListItem', position: 2, name: '痛點腳本規劃與審核', description: '依據目標客群企劃痛點腳本，精準篩選具備真實購買力的引流受眾。' },
              { '@type': 'ListItem', position: 3, name: '實體拍攝與剪輯', description: '支援顧問級出班拍攝或毛片專業後製，建立潛在客戶的專業信任感。' },
              { '@type': 'ListItem', position: 4, name: '漏斗與自動化系統建置', description: '打造前端著陸頁與後端 API 自動化派發系統，1 秒內推送商機通知。' },
              { '@type': 'ListItem', position: 5, name: '數據監控與持續優化', description: '透過深層數據追蹤，持續微調漏斗參數，確保獲客成本穩定可控。' },
              { '@type': 'ListItem', position: 6, name: '品牌數位基建架設', description: '從形象官網到數據後台，全方位建構品牌的數位根基。' },
            ],
          },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'ProfessionalService',
          name: '全鏈獲客整合行銷 - 六大核心服務',
          url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`,
          description: '從診斷到優化，完整覆蓋全鏈獲客的每一個關鍵環節，為企業打造 B2B 自動化行銷漏斗解決方案。',
          areaServed: { '@type': 'Country', name: 'TW' },
          availableLanguage: { '@type': 'Language', name: 'Chinese Traditional' },
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '六大核心服務',
            itemListElement: [
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '深度需求診斷', description: '針對企業瓶頸進行全方位拆解，精準判斷防禦型或極速型漏斗。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '專屬網站與 O2O 展間建置', description: '量身打造高轉換率形象網站與線上展示後台。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'API 即時自動化派單', description: '1 秒內透過 API 無縫派發商機至 LINE 或終端。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '廣告合規與腳本策略', description: '高轉換腳本策略企劃與廣告合規性全面審查。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '數據雷達與追蹤埋設', description: '完整建置 GTM 與 Meta/Google 追蹤代碼。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '廣告投放與持續優化', description: '全網廣告精準投放，確保獲客成本穩定可控。' } },
            ],
          },
        },
      ]);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
      const desc2 = document.querySelector('meta[name="description"]');
      if (desc2) desc2.setAttribute('content', '全鏈獲客整合行銷為高總價 B2B、電商與實體店家打造全自動印鈔漏斗。透過痛點影音引流、精準廣告投放與 API 自動化系統串接，量身打造防禦型或極速轉換漏斗，極大化廣告投報率 ROAS。');
      const canonical2 = document.querySelector('link[rel="canonical"]');
      if (canonical2) canonical2.setAttribute('href', import.meta.env.VITE_SITE_URL || 'https://example.com');
    };
  }, []);

  const services = [
    {
      icon: 'ri-search-eye-line',
      number: '01',
      en: 'Requirement Diagnosis',
      title: '深度需求診斷',
      description:
        '針對企業瓶頸進行全方位拆解，精準判斷您的商業模式適用「防禦型」或「極速型」漏斗，確保每一分預算花在刀口上。',
      features: [
        '企業獲客瓶頸全方位拆解',
        '防禦型 / 極速型漏斗判斷',
        '專屬漏斗策略規劃',
        '競品市場分析',
      ],
    },
    {
      icon: 'ri-layout-masonry-line',
      number: '02',
      en: 'O2O Website & Showroom',
      title: '專屬網站與 O2O 展間建置',
      description:
        '為企業量身打造高轉換率的形象網站與線上展示後台，建立數位信任根基。讓您的品牌在網路上擁有一個專業、高質感的數位門面。',
      features: [
        '高轉換力形象網站架設',
        '線上 O2O 展間客製建置',
        '專屬品牌網域綁定',
        '企業後台與員工權限管理',
      ],
    },
    {
      icon: 'ri-api-line',
      number: '03',
      en: 'API Auto-Dispatch',
      title: 'API 即時自動化派單',
      description:
        '捨棄傳統人工轉發。當客戶填單或觸發指定條件，系統於 1 秒內透過 API 無縫派發商機至您的 LINE 或終端，確保業務絕不漏接任何一筆合格商機。',
      features: [
        'API 自動化商機派發',
        '1 秒即時 LINE 推送',
        '表單與 CRM 無縫整合',
        '自訂觸發條件設定',
      ],
    },
    {
      icon: 'ri-shield-check-line',
      number: '04',
      en: 'Compliance & Script Strategy',
      title: '廣告合規與腳本策略',
      description:
        '針對高轉換目標撰寫腳本策略，並嚴格進行廣告合法性與平台政策審核，主動過濾高風險用詞，保護帳號安全。(註：影片實體拍攝工程為額外加值服務)',
      features: [
        '高轉換腳本策略企劃',
        '廣告合規性全面審查',
        '高風險用詞主動過濾',
        '平台政策即時監控',
      ],
    },
    {
      icon: 'ri-bar-chart-box-line',
      number: '05',
      en: 'Data Radar & Tracking',
      title: '數據雷達與追蹤埋設',
      description:
        '完整建置 GTM 與 Meta/Google 追蹤代碼，讓每一筆廣告點擊都無所遁形。精準捕捉高意願受眾的行為軌跡，為後續廣告優化提供強大數據基礎。',
      features: [
        'GTM 全站追蹤代碼建置',
        'Meta Pixel 深層事件設定',
        'Google Analytics 4 串接',
        '轉換事件精準追蹤',
      ],
    },
    {
      icon: 'ri-rocket-2-line',
      number: '06',
      en: 'Ad Deployment & Optimization',
      title: '廣告投放與持續優化',
      description:
        '全網廣告精準投放，深層追蹤客流反饋並持續微調漏斗參數，確保獲客成本穩定可控。每月提供戰略報表，讓每一分廣告預算的投報效益一目了然。',
      features: [
        '多渠道精準廣告投放',
        '高意願受眾再行銷',
        '漏斗參數持續微調',
        '每月戰略成效報表',
      ],
    },
  ];

  return (
    <div id="top" className="min-h-screen bg-white">
      <Navbar onConsultClick={handleCTA} />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#F0F4FF] to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-[#1E3A8A]/10 text-[#1E3A8A] px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-shield-check-line"></i>
              <span>企業級解決方案</span>
            </div>
            <h1 className="text-5xl font-bold text-[#1E3A8A] mb-6">六大核心服務</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              從診斷到優化，完整覆蓋全鏈獲客的每一個關鍵環節<br />
              不只帶來流量，更為您過濾出具備真實購買力的精準引流受眾
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section id="services-list" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 space-y-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row gap-8 items-stretch bg-white border-2 border-gray-100 rounded-2xl overflow-hidden hover:border-[#1E3A8A]/30 hover:shadow-xl transition-all duration-300 group ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* Left accent panel */}
              <div className="md:w-64 flex-shrink-0 bg-gradient-to-br from-[#1E3A8A] to-[#152d6b] flex flex-col items-center justify-center p-10 gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-2xl">
                  <i className={`${service.icon} text-4xl text-white`}></i>
                </div>
                <div className="text-white/30 text-6xl font-bold leading-none">{service.number}</div>
                <div className="text-white/70 text-xs tracking-widest uppercase text-center">{service.en}</div>
              </div>

              {/* Content */}
              <div className="flex-1 p-8 flex flex-col justify-center">
                <h3 className="text-2xl font-bold text-[#1E3A8A] mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6 text-base">{service.description}</p>
                <div className="grid grid-cols-2 gap-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center bg-[#1E3A8A]/10 rounded-full flex-shrink-0">
                        <i className="ri-check-line text-xs text-[#1E3A8A]"></i>
                      </div>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Traffic Matrix Section */}
      <TrafficMatrix />

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#1E3A8A] to-[#152d6b]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
            <i className="ri-calendar-check-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl font-bold text-white mb-6">
            準備好啟動您的自動化獲客漏斗了嗎？
          </h2>
          <p className="text-xl text-white/80 mb-10 leading-relaxed">
            立即預約系統評估，我們將為您量身打造最適合的引流過濾解決方案
          </p>
          <button
            onClick={handleCTA}
            className="bg-white text-[#1E3A8A] px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer shadow-xl"
          >
            <span>👉 立即預約系統評估</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
